import { render, staticRenderFns } from "./PorcentajesSentimientos.vue?vue&type=template&id=af8a2bf6&"
import script from "./PorcentajesSentimientos.vue?vue&type=script&lang=js&"
export * from "./PorcentajesSentimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports